<template>
    <div>
        <Upload
                :name="name"
                :multiple="multiple"
                :data="data"
                :disable="disable"
                :action="action"
                :show-upload-list="showUploadList"
                :on-success="onSuccess"
                :on-error="onError"
                :style="sstyle"
                :format="format"
                :accept="accept"
                :max-size="maxSize"
                :on-exceeded-size="onExceededSize"
                :on-format-error="onFormatError"
                :before-upload="beforeUpload"
                :on-progress="onProgress"
        >
            <Button icon="ios-cloud-upload-outline" @click="uploadFunc(indexx)">选择文件</Button>
            <span class="text-label">{{maxSize / 1024}}M内文件,支持类型:{{ format.length > 0 ? format.toString() : "全部" }}</span>
        </Upload>
    </div>
</template>
<script>
    export default {
        name:'upload',
        props:{
            name:{ // 上传功能名字
                type:String,
                default:'',
            },
            disable:{ // 是否禁用
                type:Boolean,
                default:false,
            },
            indexx:{ //点击上传携带参数，暂定
                type:Number,
                default:0,
            },
            multiple:{   // 多文件上传
                type:Boolean,
                default:true,
            },
            data:{  // 上传附带参数
                type:Object,
                default: function () {
                    return {};
                }
            },
            action:{    // 上传路径
                type:String,
                required:true,
            },
            showUploadList:{    // 是否显示上传列表
                type:Boolean,
                default:true,
            },
            onSuccess:{ // 上传成功回调
                type:Function,
                default:function () {}
            },
            onError:{ // 失败时回调
                type:Function,
                default:function () {
                    this.$Message.error('上传失败，请稍后再试！');
                }
            },
            sstyle:{ // 传入css样式
                type:String,
                default:''
            },
            format:{ //上传文件格式
                type:Array,
                default:function () {
                    return [];
                }
            },
            onFormatError:{ // 格式上传错误提示
                type:Function,
                default:function(){
                    this.$Message.error('文件格式错误，请上传正确的文件格式！');
                }
            },
            accept:{ // 限制文件格式 ， 上传弹出后筛选过滤文件用的
                type:String,
                default:''
            },
            maxSize:{   // 文件最大上传大小
                type:Number,
                default: 1024 * 300,
            },
            onExceededSize:{   // 大小超出限制回调
                type:Function,
                default:function () {
                    this.$Message.error("文件大小超出限制,不能超过 "+this.maxSize / 1024+"M");
                }
            },
            uploadFunc:{  // 上传执行函数
                type:Function,
                default:function () {}
            },
            beforeUpload:{ // 上传文件之前的钩子，参数为上传的文件
                type:Function,
                default:function(){}
            },
            onProgress:{
                type:Function,
                default:function(){}
            }
        },
        data(){
            return {};
        },
        methods:{

        },
    }
</script>
